module.exports = __webpack_public_path__ + "media/images/plus-icon-bbd229dcc2bc8cd18c1cac05b27f5616b0883ccabf3343b6759fddb5dc7552d3.svg";